import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import DynamicForm from "../../../Extracomponents/FormicForm";
import { useLocation, useNavigate } from "react-router-dom";
import {
  SendBroadCast,
  GetService,
  UpdateCastmessage,
} from "../../../Services/Admin/Admin";
import Content from "../../../components/Contents/Content";
import showCustomAlert from "../../../Extracomponents/CustomAlert/CustomAlert";

const Updatebroadcast = () => {
  const location = useLocation();
  const { item } = location.state;

  const [servicedata, setServicedata] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();
  const token = localStorage.getItem("token");

  // Helper function to format date for datetime-local input
  const formatDateForInput = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      // datetime-local input expects format: YYYY-MM-DDTHH:mm
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");
      const hours = String(date.getHours()).padStart(2, "0");
      const minutes = String(date.getMinutes()).padStart(2, "0");

      return `${year}-${month}-${day}T${hours}:${minutes}`;
    } catch (error) {
      console.error("Error formatting date:", error);
      return "";
    }
  };

  const getservice = async () => {
    try {
      const response = await GetService(token);
      if (response.status) {
        setServicedata(response.data);
      }
    } catch (error) {
      console.log("Error fetching services:", error);
    }
  };

  useEffect(() => {
    getservice();
  }, []);

  const formik = useFormik({
    initialValues: {
      service: item?.service ? item.service.split(",") : [],
      subject: item?.subject || "",
      message: item?.message || "",
      type: item?.type || "",
      redirecttype: item?.redirecttype || "",
      scheduleat: formatDateForInput(item?.scheduleat || item?.scheduleAt),
    },
    enableReinitialize: true, // Important: yeh allow karta hai values ko re-initialize hone

    onSubmit: async (values) => {
      if (isSubmitting) {
        console.log("Already submitting, ignoring...");
        return;
      }

      setIsSubmitting(true);

      console.log("=== SUBMIT DEBUG ===");
      console.log("Original scheduleat:", item.scheduleat || item.scheduleAt);
      console.log("Form value scheduleat:", values.scheduleat);

      const req = {
        id: item._id,
        subject: values.subject,
        message: values.message,
        type: values.type,
        redirecttype: values.redirecttype || "",
        service:
          values.type === "nonsubscribe" || values.type === "All"
            ? "All"
            : Array.isArray(values.service)
            ? values.service.join(",")
            : values.service,
      };

      // Schedule date handling - CRITICAL FIX
      if (values.scheduleat) {
        // Agar user ne date field me kuch enter kiya hai
        const originalFormatted = formatDateForInput(
          item.scheduleat || item.scheduleAt
        );

        if (values.scheduleat !== originalFormatted) {
          // Date changed hai, new date use karo
          req.scheduleat = new Date(values.scheduleat).toISOString();
        } else {
          // Date same hai, original value preserve karo
          req.scheduleat = item.scheduleat || item.scheduleAt;
        }
      } else {
        // Agar field empty hai, original value use karo
        req.scheduleat = item.scheduleat || item.scheduleAt;
      }

      console.log("Final request scheduleat:", req.scheduleat);

      try {
        const response = await UpdateCastmessage(req, token);
        if (response.status) {
          showCustomAlert(
            "Success",
            response.message,
            navigate,
            "/admin/message"
          );
        } else {
          showCustomAlert("error", response.message);
        }
      } catch (error) {
        console.error("Update error:", error);
        showCustomAlert(
          "error",
          "An unexpected error occurred. Please try again later."
        );
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  const fields = [
    {
      name: "type",
      label: "Select Type",
      type: "select",
      label_size: 6,
      col_size: 4,
      disable: false,
      options: [
        { value: "All", label: "All" },
        { value: "active", label: "Active" },
        { value: "expired", label: "Expired" },
        { value: "nonsubscribe", label: "Non Subscribe" },
      ],
      star: true,
    },
    {
      name: "service",
      label: "Select Service",
      type: "select",
      label_size: 6,
      col_size: 4,
      disable: false,
      options: [
        { value: "All", label: "All" },
        ...servicedata?.map((item) => ({
          value: item?._id,
          label: item?.title,
        })),
      ],
      star: true,
      showWhen: (values) =>
        !(values.type === "nonsubscribe" || values.type === "All"),
    },
    {
      name: "subject",
      label: "Subject",
      type: "text",
      label_size: 12,
      col_size: 4,
      disable: false,
      star: true,
    },
    {
      name: "redirecttype",
      label: "Redirect Type",
      type: "select",
      label_size: 6,
      col_size: 4,
      disable: false,
      options: [
        // { value: "All", label: "All" },
        { value: "services", label: "Services" },
        { value: "trades", label: "Trades" },
        { value: "baskets", label: "Baskets" },
        { value: "strategy", label: "Strategy" },
        { value: "watchlist", label: "Watchlist" },
        { value: "stocks", label: "Stocks" },
        { value: "screeners", label: "Screeners" },
        { value: "dii/fii", label: "DII/FII" },
        { value: "sector wise companies", label: "Sector Wise Companies" },
        { value: "market", label: "Market" },
        // { value: "ipo", label: "IPO" },
        { value: "portfolio scanner", label: "Portfolio Scanner" },
        { value: "news", label: "News" },
        { value: "blog", label: "Blog" },
      ],
      // star: true,
    },
    {
      name: "scheduleat",
      label: "Schedule At",
      type: "datetime",
      label_size: 12,
      col_size: 4,
      disable: false,
      // star: true,
    },
    {
      name: "message",
      label: "Message",
      type: "ckeditor",
      label_size: 12,
      col_size: 12,
      disable: false,
      star: true,
    },
  ];

  return (
    <Content
      Page_title="Update Broadcast"
      button_status={false}
      backbutton_status={true}
      backForward={true}
    >
      {servicedata && servicedata.length > 0 && (
        <DynamicForm
          fields={fields.filter(
            (field) => !field.showWhen || field.showWhen(formik.values)
          )}
          formik={formik}
          btn_name="Update Broadcast"
          btn_name1="Cancel"
          sumit_btn={true}
          btn_name1_route={"/admin/message"}
          additional_field={<></>}
        />
      )}
    </Content>
  );
};

export default Updatebroadcast;
